import { createSelector } from 'reselect'

import { getRtmOfferings } from '../../lib'

import { selectStrategicInitiativesOfferingsList } from './selectStrategicInitiativesOfferingsList'
import { selectStrategicInitiativesSelectedRtm } from './selectStrategicInitiativesSelectedRtm'

export const selectStrategicInitiativesOfferingOptions = createSelector(
  [selectStrategicInitiativesOfferingsList, selectStrategicInitiativesSelectedRtm],
  getRtmOfferings
)
